import { render, staticRenderFns } from "./PreviewMatching.vue?vue&type=template&id=19943819"
import script from "./PreviewMatching.vue?vue&type=script&lang=js"
export * from "./PreviewMatching.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports